export const Marquee = ({ items }) => {
  const row = (ariaHidden) => (
    <div aria-hidden={ariaHidden} className="flex shrink-0 items-center">
      {items.map((t, i) => (
        <span key={i} className="flex items-center shrink-0">
          <span className="font-serif italic text-2xl md:text-4xl text-zinc-500 px-8 whitespace-nowrap">
            {t}
          </span>
          <svg width="12" height="12" viewBox="0 0 12 12" className="shrink-0">
            <rect x="2.5" y="2.5" width="7" height="7" transform="rotate(45 6 6)" fill="none" stroke="#D4AF37" strokeWidth="1.2" />
          </svg>
        </span>
      ))}
    </div>
  );
  return (
    <div className="relative overflow-hidden border-y border-[#d4af37]/15 bg-[#0c0c0e] py-6">
      <div className="marquee-track flex w-max">
        {row(false)}
        {row(true)}
      </div>
    </div>
  );
};

export default Marquee;
